import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f61842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leaf-video" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leaf-video__bg" }, null, -1))
const _hoisted_3 = {
  muted: "",
  loop: "",
  autoplay: "",
  playsinline: ""
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { resolvePath } from '@/utils/Path';

export default /*#__PURE__*/_defineComponent({
  __name: 'LeafVideo',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("video", _hoisted_3, [
      _createElementVNode("source", {
        src: _unref(resolvePath)(require('@/assets/videos/leaf.webm')),
        type: "video/webm"
      }, null, 8, _hoisted_4),
      _createElementVNode("source", {
        src: _unref(resolvePath)(require('@/assets/videos/leaf.mp4')),
        type: "video/mp4"
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})